import axiosInstance from '../services/AxiosInstance';

export function getFacingDirection(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`facing-direction?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function deleteFacingDirection(id) {
    return axiosInstance.delete(`facing-direction/${id}`);
}

export function createFacingDirection(id) {
    return axiosInstance.post(`facing-direction`,id);
}

export function updateFacingDirection(id, data) {
    return axiosInstance.put(`facing-direction/${id}`,data);
}
